export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["Approved"] = "approved";
    ApprovalStatus["Deleted"] = "deleted";
    ApprovalStatus["Failed"] = "failed";
    ApprovalStatus["Pending"] = "pending";
    ApprovalStatus["Rejected"] = "rejected";
})(ApprovalStatus || (ApprovalStatus = {}));
//# sourceMappingURL=approval-status.js.map